
import { ElectronFunctions } from "@/utils/electron/electron";
import { IElectronPrinter } from "@/utils/electron/electron-printer";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
export default Vue.extend({
	data(){
		return {
			defaultPrinterId: "",
			copyCount: 0
		};
	},
	props: {
		printers: {
			type: Array as ()=>IElectronPrinter[],
			required: true
		},
		layoutId: {
			type: Number,
			required: true
		}
	},
	computed: {
		printerItems():ISelectItem<string>[]{
			let result:ISelectItem<string>[] = [
				{
					text: this.$ct("common.none"),
					value: ""
				}
			];

			result.push(...this.printers.map(p=>{
				return {
					text: p.name,
					value: p.deviceId
				};
			}));

			return result;
		},
	},
	methods: {
		close(){
			this.$emit("close");
		},
		save(){
			ElectronFunctions.setDefaultPrinterIdForReminderLayout(this.layoutId, this.defaultPrinterId);
			if (this.defaultPrinterId == ""){
				ElectronFunctions.setCopyCountForReminderLayout(this.layoutId, 0);
			}else{
				ElectronFunctions.setCopyCountForReminderLayout(this.layoutId, this.copyCount);
			}
			this.close();
		}
	},
	mounted(){
		this.defaultPrinterId = ElectronFunctions.getDefaultPrinterIdForReminderLayout(this.layoutId);
		this.copyCount = ElectronFunctions.getCopyCountForReminderLayout(this.layoutId);
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
